import { FunnelExitPopup } from '@insify/exit-popup';
import { useLocation } from 'react-router-dom';

import { useCoBranding } from '../../hooks/useCoBranding';

export const ExitPopup: React.FC = () => {
  const { pathname } = useLocation();
  const { partnerName } = useCoBranding();

  return (
    <FunnelExitPopup
      enabled={!partnerName}
      path={pathname}
      contentfulApiKey={window.insify_runtime_config.CONTENTFUL_API_KEY}
      contentfulContentTypeId='frPncConfig'
      contentfulEntryId='2tECkE4R48XIQ8tXqZLfMn'
    />
  );
};
